"use client";
import { getCustomParkingVerbiage } from "@gettactic/helpers";
import { useAuthenticated } from "@gettactic/hooks";

export const useCustomParkingVerbiageOnWeb = () => {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();

  const orgSlug = authenticatedUser?.slug ?? "";
  return getCustomParkingVerbiage(orgSlug);
};
